import { FLAGS, useFlag, useFlagClient } from '@iheartjane/feature-flags';
import { useEffect } from 'react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';

import { useManager } from '@jane/business-admin/data-access';
import { useOnlyAnalyticsPermission } from '@jane/business-admin/hooks/useHasPermissions';
import { useLogoutAndNavigateToLogin } from '@jane/business-admin/hooks/useLogoutAndNavigateToLogin';
import {
  businessPaths,
  LOGIN_NAVIGATION_STATE,
} from '@jane/business-admin/util';

export const RequireAnonymousUser = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const { data: currentManager, isFetched } = useManager();
  const onlyAnalyticsUser = useOnlyAnalyticsPermission();
  const logout = useLogoutAndNavigateToLogin();
  const flagClient = useFlagClient();
  const isPermissionGateEnabled = useFlag(FLAGS.c1PermissionGate, false);

  useEffect(() => {
    //TODO: This is some janky shit. Figure out a better way to handle this.
    document.body.style.background =
      'linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), #5E1FF0';
    return () => {
      //TODO: This is some janky shit. Figure out a better way to handle this.
      document.body.style.background = '#FFF';
    };
  }, []);

  useEffect(() => {
    if (!isFetched || !currentManager?.manager?.id || !flagClient) return;

    const hasAnyPermission = !!currentManager?.manager?.permissions?.length;
    const isClientRole = currentManager?.manager?.role === 'client';
    // c1-permission-gate and c1-fulfillment-enabled are rolled out in lockstep,
    // so the "gate off, fulfillment on" state is theoretical-only — the code
    // handles it for defense-in-depth but the team does not operate it. Any
    // future change that breaks the lockstep must revisit these gates.
    //
    // Gate off: legacy role-based admission (role=client only).
    // Gate on: admit role=client managers (regardless of permissions) plus
    // anyone holding ≥1 permission.
    const isAuthorized = isPermissionGateEnabled
      ? hasAnyPermission || isClientRole
      : isClientRole;

    if (isAuthorized) {
      navigate(businessPaths.loggedInRoot(onlyAnalyticsUser), {
        state: LOGIN_NAVIGATION_STATE,
      });
    } else {
      logout();
      navigate({
        pathname: '/login',
        search: '?permissionError=true',
      });
    }
  }, [
    currentManager?.manager?.id,
    currentManager?.manager?.permissions?.length,
    currentManager?.manager?.role,
    flagClient,
    isFetched,
    isPermissionGateEnabled,
    logout,
    navigate,
    onlyAnalyticsUser,
  ]);

  return !isFetched ? null : <>{children}</>;
};
